import $ from 'jquery';
import PhotoSwipe from 'photoswipe';
import enquire from 'enquire.js';
import objectFitImages from 'object-fit-images';
import { breakpoints } from './utils';

function createContainer() {
    if (!document.querySelector('.pswp')) {
        const container = `
            <!-- Root element of PhotoSwipe. Must have class pswp. -->
            <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

                <!-- Background of PhotoSwipe.
                     It's a separate element as animating opacity is faster than rgba(). -->
                <div class="pswp__bg"></div>

                <!-- Slides wrapper with overflow:hidden. -->
                <div class="pswp__scroll-wrap">

                    <!-- Container that holds slides.
                        PhotoSwipe keeps only 3 of them in the DOM to save memory.
                        Don't modify these 3 pswp__item elements, data is added later on. -->
                    <div class="pswp__container">
                        <div class="pswp__item"></div>
                        <div class="pswp__item"></div>
                        <div class="pswp__item"></div>
                    </div>
                </div>
            </div>
        `;

        $('body').append(container);
    }
}

function loadGallery(image) {
    const items = [{
        src: image.getAttribute('src'),
        w: image.getAttribute('width'),
        h: image.getAttribute('height'),
    }];

    const options = {
        bgOpacity: 0.9,
    };

    const gallery = new PhotoSwipe(document.querySelector('.pswp'), null, items, options);
    gallery.init();
}

const images = Array.from(document.querySelectorAll('.js-image'));

if (images.length) {
    enquire.register(breakpoints.portable, {
        match: () => {
            createContainer();
            images.forEach(image => image.addEventListener('click', () => loadGallery(image)));
        },
    });
}

objectFitImages();



// WEBPACK FOOTER //
// ./app/scripts/components/images.js